enum EWidgetType {
  CHART = 'chart',
  TABLE = 'table',
}

export default EWidgetType;
